import axios from "axios";
//const baseURL = "http://192.168.100.46:4001/api/";
const baseURL = "https://api.isaacnewtonbolivia.com/api/";
const apiNewton = axios.create({
	baseURL: baseURL,
});

export default apiNewton;
